var map = {
	"./login-background.png": "kaMZ",
	"./logo.png": "9f/Q"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "w+fZ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b122 ^\.\/.*$
// module id = w+fZ
// module chunks = 0